module.exports = __webpack_public_path__ + "static/media/cases_logos_eventos_08.0c50eaa7.jpg";